import { c as _c } from "react/compiler-runtime";
import React from 'react';
import type { BaseIconProps } from '../types';
interface IconProps extends BaseIconProps {
  children: React.ReactNode;
  viewBox?: string;
  fill?: string;
  stroke?: string;
  strokeWidth?: string | number;
  strokeLinecap?: 'round' | 'butt' | 'square';
  strokeLinejoin?: 'round' | 'miter' | 'bevel';
  style?: React.CSSProperties;
  flip?: boolean;
}
export const Path: React.FC<React.SVGProps<SVGPathElement>> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <path {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const Polyline: React.FC<React.SVGProps<SVGPolylineElement>> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <polyline {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const Rect: React.FC<React.SVGProps<SVGRectElement>> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <rect {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const Line: React.FC<React.SVGProps<SVGLineElement>> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <line {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const G: React.FC<React.SVGProps<SVGGElement>> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <g {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const Circle: React.FC<React.SVGProps<SVGCircleElement>> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <circle {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const Polygon: React.FC<React.SVGProps<SVGPolygonElement>> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <polygon {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};

// Gradient and definition elements
export const Defs: React.FC<React.SVGProps<SVGDefsElement>> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <defs {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const ClipPath: React.FC<React.SVGProps<SVGClipPathElement>> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <clipPath {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const LinearGradient: React.FC<React.SVGProps<SVGLinearGradientElement>> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <linearGradient {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const RadialGradient: React.FC<React.SVGProps<SVGRadialGradientElement>> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <radialGradient {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const Stop: React.FC<React.SVGProps<SVGStopElement>> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <stop {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
const Icon: React.FC<IconProps> = t0 => {
  const $ = _c(35);
  let children;
  let color;
  let fill;
  let props;
  let size;
  let stroke;
  let strokeLinecap;
  let strokeLinejoin;
  let strokeWidth;
  let t1;
  let t2;
  let t3;
  let t4;
  let viewBox;
  if ($[0] !== t0) {
    ({
      children,
      width: t1,
      height: t2,
      size,
      color,
      viewBox,
      fill,
      stroke,
      strokeWidth,
      strokeLinecap,
      strokeLinejoin,
      style: t3,
      flip: t4,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = color;
    $[3] = fill;
    $[4] = props;
    $[5] = size;
    $[6] = stroke;
    $[7] = strokeLinecap;
    $[8] = strokeLinejoin;
    $[9] = strokeWidth;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = viewBox;
  } else {
    children = $[1];
    color = $[2];
    fill = $[3];
    props = $[4];
    size = $[5];
    stroke = $[6];
    strokeLinecap = $[7];
    strokeLinejoin = $[8];
    strokeWidth = $[9];
    t1 = $[10];
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
    viewBox = $[14];
  }
  const width = t1 === undefined ? 24 : t1;
  const height = t2 === undefined ? 24 : t2;
  let t5;
  if ($[15] !== t3) {
    t5 = t3 === undefined ? {} : t3;
    $[15] = t3;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const style = t5;
  const flip = t4 === undefined ? false : t4;
  const iconSize = size || width;
  const iconHeight = size || height;
  const t6 = color || "rgba(var(--text-color))";
  const t7 = flip ? "rotate(180deg)" : undefined;
  let t8;
  if ($[17] !== style || $[18] !== t6 || $[19] !== t7) {
    t8 = {
      color: t6,
      transform: t7,
      ...style
    };
    $[17] = style;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let svgProps;
  if ($[21] !== fill || $[22] !== iconHeight || $[23] !== iconSize || $[24] !== props || $[25] !== stroke || $[26] !== strokeLinecap || $[27] !== strokeLinejoin || $[28] !== strokeWidth || $[29] !== t8 || $[30] !== viewBox) {
    svgProps = {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconSize,
      height: iconHeight,
      style: t8,
      ...props
    };
    if (viewBox !== undefined) {
      svgProps.viewBox = viewBox;
    }
    if (fill !== undefined) {
      svgProps.fill = fill;
    }
    if (stroke !== undefined) {
      svgProps.stroke = stroke;
    }
    if (strokeWidth !== undefined) {
      svgProps.strokeWidth = strokeWidth;
    }
    if (strokeLinecap !== undefined) {
      svgProps.strokeLinecap = strokeLinecap;
    }
    if (strokeLinejoin !== undefined) {
      svgProps.strokeLinejoin = strokeLinejoin;
    }
    $[21] = fill;
    $[22] = iconHeight;
    $[23] = iconSize;
    $[24] = props;
    $[25] = stroke;
    $[26] = strokeLinecap;
    $[27] = strokeLinejoin;
    $[28] = strokeWidth;
    $[29] = t8;
    $[30] = viewBox;
    $[31] = svgProps;
  } else {
    svgProps = $[31];
  }
  let t9;
  if ($[32] !== children || $[33] !== svgProps) {
    t9 = <svg {...svgProps}>{children}</svg>;
    $[32] = children;
    $[33] = svgProps;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  return t9;
};
export default Icon;